import {matchPath, useMatches} from "react-router-dom";

export function useRouteMatch(patterns: readonly string[]) {
    const matches = useMatches()
    for (let i = 0; i < patterns.length; i += 1) {
        const pattern = patterns[i];
        const matchingPath = matches.filter((match) =>  matchPath(pattern, match.pathname))
        if (matchingPath.length > 0) {
            return pattern;
        }
    }
    return null;
}
